import { useState } from 'react';

const projects = [
  {
    id: 1,
    title: 'Custom Deck Installation',
    category: 'Decking',
    location: 'Shelton, CT',
    image: 'https://static.readdy.ai/image/f974ae4a89bf06aece5244b03610bc1c/44cf4c1c77395d0dd64a4030a0f02ead.png',
    featured: true
  },
  {
    id: 2,
    title: 'School Renovation',
    category: 'Remodeling',
    location: 'Terryville, CT',
    image: 'https://static.readdy.ai/image/f974ae4a89bf06aece5244b03610bc1c/ba0709cc38c19f6fdee3628811245c7b.jpeg'
  },
  {
    id: 3,
    title: 'Complete House Framing',
    category: 'Framing',
    location: 'Stamford, CT',
    image: 'https://static.readdy.ai/image/f974ae4a89bf06aece5244b03610bc1c/9046abe3213fecd7e731bcd242533e5d.png'
  },
  {
    id: 4,
    title: 'Complete House Framing',
    category: 'Framing',
    location: 'Tolland, CT',
    image: 'https://static.readdy.ai/image/f974ae4a89bf06aece5244b03610bc1c/ff53e145b8da8a191c710e7b06269004.png',
    featured: true
  }
];

export default function Portfolio() {
  const [activeFilter, setActiveFilter] = useState('All');
  const filters = ['All', 'Residential', 'Commercial', 'Remodeling', 'Decking', 'Framing'];

  const filteredProjects = activeFilter === 'All' 
    ? projects 
    : projects.filter(project => project.category === activeFilter);

  return (
    <section id="portfolio" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Header with Filters */}
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between mb-12">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6 lg:mb-0">
            Recent Projects
          </h2>
          
          {/* Filter Tabs */}
          <div className="flex flex-wrap gap-3">
            {filters.map((filter) => (
              <button
                key={filter}
                onClick={() => setActiveFilter(filter)}
                className={`px-6 py-2 rounded-full text-sm font-medium transition-all whitespace-nowrap ${
                  activeFilter === filter
                    ? 'bg-brand text-white'
                    : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                }`}
              >
                {filter}
              </button>
            ))}
          </div>
        </div>

        {/* Projects Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {filteredProjects.map((project) => (
            <div
              key={project.id}
              className={`group relative rounded-2xl overflow-hidden cursor-pointer ${
                project.featured ? 'md:col-span-2 md:row-span-1' : ''
              }`}
            >
              {/* Image Container */}
              <div className="relative w-full h-96 overflow-hidden">
                <img
                  src={project.image}
                  alt={project.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
                />

                {/* Featured Badge */}
                {project.featured && (
                  <div className="absolute top-6 right-6 bg-brand text-white text-xs font-semibold px-4 py-2 rounded-full whitespace-nowrap">
                    Featured Project
                  </div>
                )}

                {/* Info Overlay */}
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent px-6 py-6">
                  <span className="text-brand text-xs font-semibold uppercase tracking-widest mb-1 block">
                    {project.category}
                  </span>
                  <h3 className="text-white text-xl font-bold leading-tight mb-1">
                    {project.title}
                  </h3>
                  <div className="flex items-center gap-1 text-white/70 text-sm">
                    <i className="ri-map-pin-line text-brand" />
                    <span>{project.location}</span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
